module.exports = "/assets/data/09762b8c8718b35c14e9bab3db767d3c-BA12.data.json";